import * as React from "react"
import { useEffect } from "react";
import { useSignal } from "@preact/signals-react";
import {TabsSeeker} from "@ui-seeker/core";

import { GROUPED_BY } from "@constants";
import { isLoadingCommonFilters } from "@signals";
import { catalogueAnalyzerTabSelected } from "./@signals";
import CatalogueAnalyzerMainSiteWarning from "./WarningMainSites";


const TABS = [
	{label: 'Brand', value: GROUPED_BY.BRAND},
	{label: 'Category', value: GROUPED_BY.CATEGORY}
]

export default function CatalogueAnalyzerTabs() {
	const showTabs = useSignal(false)

	useEffect(() => {
		if (isLoadingCommonFilters.value)
			showTabs.value = true
	}, [isLoadingCommonFilters.value])

	if (!showTabs.value) return <></>

    return <TabsSeeker
		tabs={TABS}
		value={catalogueAnalyzerTabSelected.value}
		onChange={(_, newValue) => {
            catalogueAnalyzerTabSelected.value = newValue
            isLoadingCommonFilters.value = true
        }}
	/>
}